import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { WebTypeId } from '@previo/codebooks'
import type { PropertyModulesType, PropertySalesmanType } from '~/store/property/modules/types'
import { usePropertyAPI } from '~/http/property'
import type { PropertyModules, PropertySalesman } from '~/http/property/types'

export const usePropertyModuleStore = defineStore('property-module', () => {
  const loading = ref<boolean>(false)
  const isLoaded = ref<boolean>(false)
  const modules = ref<PropertyModulesType>({
    isOfferModuleActive: false,
    isOwnerSystemActive: false,
    webSiteModuleWebType: 0,
  })

  const isSalesmanLoaded = ref<boolean>(false)
  const salesman = ref<PropertySalesmanType>({
    id: 0,
    name: '',
  })

  const load = (): Promise<void> => {
    loading.value = true

    return usePropertyAPI()
      .loadModules()
      .then((r: PropertyModules) => {
        isLoaded.value = true

        modules.value = {
          isOwnerSystemActive: r.isOwnerSystemActive,
          webSiteModuleWebType: r.webSiteModuleWebType,
          isOfferModuleActive: r.isOfferModuleActive,
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  const loadSalesman = (): Promise<void> => {
    loading.value = true

    return usePropertyAPI()
      .loadSalesman()
      .then((r: PropertySalesman | void) => {
        if (r !== undefined) {
          isSalesmanLoaded.value = true

          salesman.value = {
            id: r.salesmanId,
            name: r.name,
          }
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  const isLoading = (): boolean => {
    return isLoading()
  }

  const isOfferModuleActive = (): boolean => {
    return modules.value.isOfferModuleActive
  }

  const isOwnerSystemActive = (): boolean => {
    return modules.value.isOwnerSystemActive
  }

  const getSalesmanId = (): number => {
    return salesman.value.id
  }

  const getSalesmanName = (): string => {
    return salesman.value.name
  }

  const isWordPress = computed((): boolean => {
    return modules.value.webSiteModuleWebType === WebTypeId.WORDPRESS
  })

  return {
    load,
    isLoading,
    isLoaded,
    isOwnerSystemActive,
    loadSalesman,
    isSalesmanLoaded,
    getSalesmanId,
    getSalesmanName,
    isWordPress,
    isOfferModuleActive,
  }
})
